<template>
  <div>
    <el-container style="width: 100%">
      <el-header>
        <el-button round @click="onRefersh">{{ generateCustomizeString('refresh') }}</el-button>
        <el-button round @click="createClick">{{ generateCustomizeString('add') }}</el-button>
      </el-header>
      <el-table :data="adBannerData" tooltip-effect="dark" style="width: 96%; margin: 10px auto; margin-bottom:60px;" v-loading.body="bannerListLoading">
        <el-table-column prop="banner_title" :label="generateCustomizeString('bannerTitle')" width="150">
        </el-table-column>
        <el-table-column :label="generateCustomizeString('bannerImage')" width="350">
          <template slot-scope="scope">
            <img :src="scope.row.img_url" style="width:auto;height:100px;" />
          </template>
        </el-table-column>
        <el-table-column prop="action_url" :label="generateCustomizeString('actionUrl')" width="300">
        </el-table-column>
        <el-table-column prop="sort_by" :label="generateCustomizeString('sortWeight')">
        </el-table-column>
        <!-- <el-table-column prop="created_at" :label="generateCustomizeString('createAt')">
        </el-table-column> -->
        <el-table-column prop="status" :label="generateCustomizeString('bannerActivity')">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 1" type="success" close-transition>
              {{generateCustomizeString('moduleReady')}}
            </el-tag>
            <el-tag v-else type="info" close-transition>
              {{generateCustomizeString('moduleWaitForReview')}}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="pc_status" :label="generateCustomizeString('bannerPCActivity')">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.pc_status === 1" type="success" close-transition>
              {{generateCustomizeString('moduleReady')}}
            </el-tag>
            <el-tag v-else type="info" close-transition>
              {{generateCustomizeString('moduleWaitForReview')}}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="generateCustomizeString('operate')" width="180">
          <template slot-scope="scope">
            <el-button @click="editClick(scope.row)" type="text" size="small">{{generateCustomizeString('edit')}}</el-button>
            <el-button @click="deleteClick(scope.row)" type="text" size="small">{{generateCustomizeString('delete')}}</el-button>
            <el-dialog :title="generateCustomizeString('noticeConfirm')" :visible.sync="dialogVisible" width="30%" :append-to-body="true">
              <span>{{generateCustomizeString('deleteBanner')}}</span>
              <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">{{generateCustomizeString('deleteCancel')}}</el-button>
                <el-button type="primary" @click="deleteBanner()">{{generateCustomizeString('deleteConfirm')}}</el-button>
              </span>
            </el-dialog>
          </template>
        </el-table-column>
      </el-table>
      <el-footer style="position: fixed; bottom: 0; width: 100%; z-index:9999; padding-top:15px;">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="15" layout="total, prev, pager, next" :total="currentTotal">
        </el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

export default {
  name: 'BannerEdit',
  props: {
    groupId: String
  },
  data() {
    return {
      bannerListLoading: false,
      currentPage: 1,
      currentTotal: 0,
      adBannerData: [],
      dialogVisible: false,
      selectDeleteId: 0
    }
  },
  created() {
    this.fetchBanner(this.currentPage)
  },
  methods: {
    generateCustomizeString,
    handleCurrentChange(val) {
      // this.fetchData(val)
      console.log('handleCurrentChange')
    },
    fetchBanner(page, group_id) {
      console.log(group_id)
      if (this.bannerListLoading) return
      this.bannerListLoading = true
      request({
        url: 'banner/list',
        method: 'get',
        params: {
          page: page,
          template_id: this.$route.params.themeId,
          group_id: group_id || this.groupId
        }
      })
        .then((res) => {
          console.log(res.data)
          const data = res.data
          const meta = res.meta
          for (let i = 0; i < res.data.length; i++) {
            var obj = {}
            obj.id = res.data[i].id
            obj.banner_title = res.data[i].title
            if (res.data[i].img_url) {
              obj.img_url = res.data[i].img_url + '?imageView2/5/w/500/h/150/q/75|imageslim'
            }
            obj.action_url = res.data[i].action_url
            obj.sort_by = res.data[i].order_weight
            obj.status = res.data[i].status
            obj.pc_status = res.data[i].pc_status
            data[i] = obj
          }
          this.adBannerData = data
          this.currentPage = meta.current_page
          this.currentTotal = meta.total
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.bannerListLoading = false
        })
    },
    deleteClick(row) {
      this.selectDeleteId = row.id
      this.dialogVisible = true
    },
    onRefersh() {
      this.fetchBanner(this.currentPage)
    },
    createClick() {
      this.$router.push({
        name: 'CreateBanner',
        params: { groupId: this.groupId }
      })
    },
    editClick(row) {
      this.$router.push({
        name: 'EditBanner',
        params: {
          bannerId: row.id,
          groupId: this.groupId
        }
      })
    },
    deleteBanner() {
      if (this.selectDeleteId === 0) return
      request({
        url: 'banner/' + this.selectDeleteId,
        method: 'delete'
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('deletedSuccessfully'),
              type: 'success'
            })
          } else {
            this.$message.error(this.generateCustomizeString('deleteFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('deleteFailed'))
        })
        .finally(() => {
          this.fetchBanner(this.currentPage)
          this.dialogVisible = false
          this.selectDeleteId = 0
        })
    }
  }
}
</script>

<style lang="less" scoped>

</style>
